var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C9.18 2.25 6.57 3.46 4.75 5.49V3C4.75 2.59 4.41 2.25 4 2.25C3.59 2.25 3.25 2.59 3.25 3V8C3.25 8.41 3.59 8.75 4 8.75H9C9.41 8.75 9.75 8.41 9.75 8C9.75 7.59 9.41 7.25 9 7.25H5.25C6.78 5.07 9.28 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 12.41 20.59 12.75 21 12.75C21.41 12.75 21.75 12.41 21.75 12C21.75 6.62 17.38 2.25 12 2.25Z",
    fill: "var(--color-color11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.25H15C14.59 15.25 14.25 15.59 14.25 16C14.25 16.41 14.59 16.75 15 16.75H18.75C17.22 18.93 14.72 20.25 12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 11.59 3.41 11.25 3 11.25C2.59 11.25 2.25 11.59 2.25 12C2.25 17.38 6.62 21.75 12 21.75C14.82 21.75 17.43 20.54 19.25 18.51V21C19.25 21.41 19.59 21.75 20 21.75C20.41 21.75 20.75 21.41 20.75 21V16C20.75 15.59 20.41 15.25 20 15.25Z",
    fill: "var(--color-color11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.8c72c37d1458336bc738a4a96242b5da.svg";
export { ForwardRef as ReactComponent };